import * as customerManager from '$domain/model/customer/customer.manager'

export const getCustomerPersonalData = () => customerManager.getCustomerPersonalData()



// WEBPACK FOOTER //
// ./src/services/customer/personalDataRecovery/personalDataRecovery.service.ts